import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import {
  Row,
  Col,
  Table,
  Button,
} from 'reactstrap';
import { fetchComponentsInitAction } from '../../../../../actions/instances/components';
import './SelectComponentModal.scss';
import Icon from '../../../../atoms/Icon/Icon';

const SelectComponentModal = ({
  onItemSelected,
}) => {
  const {
    components,
    didLoadComponents,
    isLoadingComponents,
  } = useSelector(state => state.buildingComponentInstance);
  const dispatch = useDispatch();
  useEffect(() => {
    if (!didLoadComponents && !isLoadingComponents) {
      dispatch(fetchComponentsInitAction());
    }
  }, []);
  return (
    <div>
      <Row>
        <Col md={12}>
          <Table responsive striped bordered>
            <colgroup>
              <col width="10%" />
              <col width="60%" />
              <col width="20%" />
              <col width="10%" />
            </colgroup>
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Dynasty</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {components.map(comp => (
                <tr>
                  <td>{comp.code}</td>
                  <td>{`${comp.name} [${comp.code}]`}</td>
                  <td>{`${comp.dynasty.name} [${comp.dynasty.code}]`}</td>
                  <td className="text-center">
                    <Button size="sm" color="light" onClick={() => onItemSelected(comp)}>
                      <Icon icon="check" color="#000" />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Col>
      </Row>
    </div>
  );
};

SelectComponentModal.propTypes = {
  onItemSelected: PropTypes.func.isRequired,
};

SelectComponentModal.defaultProps = {

};

export default SelectComponentModal;
